module.exports = __webpack_public_path__ + "static/media/product_sample_14.20b79e6e.jpg";